<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-paste"></i>
        Agent information
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">webcastle</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Server</a>
        </li>
      </ul>
    </div>
    <vcl-facebook v-if="loading"></vcl-facebook>
    <b-card v-else>
      <div class="d-flex flex-wrap align-items-center">
        <div class="title mr-auto mb7" v-if="server && server.url">
          <!-- <i class='fa fa-align-justify' v-if="server && server.url"></i> -->
          <b-form-select v-model="server.id" v-on:change="change_target($event, server)" size="sm" style="max-width: 20rem;" v-if="agent_list && agent_list.length">
            <option v-for="item in agent_list" :key="item.id" :value="item.id">{{item.url}}</option>
          </b-form-select>
          <span v-else>Agent Info</span>
        </div>
        <div class="mb7">
          <strong class="pull-right">Installed Date : {{server.created_at | sdate}}</strong>
        </div>
      </div>
      <hr>
      <template v-if="quick_setting_status" class="animated fadeIn fadeOut">
        <RuleQuickSetup
          v-if="default_rule && default_rule.rule"
          :rule_selected="sel_domain.rule"
          :domain="sel_domain.domain"
          :quick_setting="quick_setting"
          :ico="ico"
          :is_one="is_one"
          :crs_rule="default_rule.rule"
          :setting_level="setting.level"
          :setting_mode="setting.mode"
          :user="user"
          :is_first="is_first"

          @save_default="save_default"
          @status="() => { quick_setting_status = false; is_first = false }"
          @quick_setting_update="(data) => { quick_setting = Object.assign({}, quick_setting, data) }"
        >
        </RuleQuickSetup>
      </template>
      <template v-if="server && !quick_setting_status">
        <b-row class="row mb-2" v-if="server && !quick_setting_status">
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="" style="letter-spacing:-1px;">
              WEBCastle Engine (global) On / Off
            </label>
          </b-col>
          <b-col class="col-xl-8 col-md-12  d-flex align-self-center">
            <div class="checkbox-switch">
              <input type="checkbox" class="input-checkbox" name="switch01" id="switch01" :disabled="server.is_del" v-model="setting.status" v-on:change="status_save($event, setting.status)" switch>
              <div class="checkbox-animate">
                <span class="checkbox-off">OFF</span>
                <span class="checkbox-on">ON</span>
              </div>
            </div>
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center flex-row-reverse">
            <button type="button" class="btn btn-sm btn-insert" tabindex="4" @click="quick_setting_status = true" :disabled="setting_lock">
              Quick Setup
            </button>
          </b-col>
        </b-row>
        <b-card v-if="server && !quick_setting_status">
          <b-row class="mb-2" v-if="server.os_type">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="" style="cursor: pointer;" @click="modal_name = true">
                NickName
                <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <span @click="server.is_del ? nickname_modify_modal : nickname_modify_modal = true" style="cursor: pointer; color: skyblue;">{{ server.nickname }}</span>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="">
                IP
              </label>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              {{server.ip_addr || '-'}}
            </b-col>
          </b-row>
          <b-row class="mb-2" v-if="server.os_type">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="">
                OS
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              {{server.os_type  || '-'}}
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="">
                Version
              </label>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              {{server.version  || '-'}}
            </b-col>
            <!-- Todo : online / offline 상태를 보여주어야함
            <b-col sm="2">
              Status
              <br>
              <b-badge variant="success" v-if="info.ms">Online</b-badge>
              <b-badge v-else variant="secondary">Offline</b-badge>
            </b-col> -->
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" style="cursor: pointer;">
              <label class="col-form-label" for="" @click="explain_user_crs = true">
                Virtual Domain Selection
                <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 mt-3">
              <b-form-select class="form-control" v-model="sel_domain.domain" @change="change_domain($event, sel_domain.id)" size="sm" style="max-width: 20rem;" :disabled="server.is_del ? lock : lock = false">
                <option v-for="item in server.policy_json.domains" :key="item.id" :value="item.domain">{{item.domain}}</option>
              </b-form-select>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" style="cursor: pointer;">
              <label class="col-form-label" for="" style="cursor: pointer;" @click="explain_level = true">
                Policy Security Level
                <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 mt-3">
              <b-form-radio-group style="cursor: pointer;" id="ph_level" v-model="setting.level" :options="codes.WAF_LEVEL" :disabled="server.is_del ? lock : setting_lock"></b-form-radio-group>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" style="cursor: pointer;">
              <label class="col-form-label" for="" @click="explain_mode = true">
                Firewall Mode
                <span class="font_14 text-info" style="cursor: pointer;"><i class="fas fa-question-circle" @click="explain_mode = true"></i></span>
                <!--  <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span> :
                <b-badge v-if="setting.mode == 0" variant="secondary">Off</b-badge>
                <b-badge v-if="setting.mode == 1" variant="warning">Detection</b-badge>
                <b-badge v-if="setting.mode == 2" variant="danger">Block</b-badge> -->
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 mt-4">
              <b-form-radio-group id="ph_mode" v-model="setting.mode" :options="codes.WAF_MODE_OPTION_ENG" :disabled="server.is_del ? lock : setting_lock"> </b-form-radio-group>
            </b-col>
            <b-col class="col-xl-6 col-md-12 d-flex align-self-center flex-row-reverse">
              <div class="pull-right">
                <!-- <b-button block size="sm" class="mb-2" variant="success" @click="rule_confirm = true">Apply</b-button> -->
                <!-- <b-button block size="sm" class="mb-2" variant="warning" @click="apply_modal = true">Apply to other servers</b-button> -->
                <b-button block size="sm" class="mb-2" variant="add" @click="explain_user_crs = true">Domain Manage</b-button>
                <b-button block size="sm" class="mb-2" variant="danger"  v-if="server.is_alive" @click="modal_del = true; del_info = server">Delete</b-button>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-5">
            <b-col class="col-xl-12 col-md-12 text-warning">
              <b-button v-if="server.is_del" class="float-left" size="sm" variant="warning" :disabled="lock">Agent was deleted</b-button>
              <b-button class="float-right" size="sm" variant="primary" @click="list()">List</b-button>
            </b-col>
          </b-row>
        </b-card>
        <!-- 탭부분 시작 -->
        <b-tabs v-model="tabIndex" v-if="server && !quick_setting_status">
          <!-- 방화벽 기본 정책 설정 -->
          <b-tab style="cursor: pointer;" title="Policy (CRS)">
            <b-row>
              <b-col>
                <strong>You can set firewall policies, only enable or disable</strong>
                <!-- 1. Quick은 사용하는 서비스 선택, (기본 설정들 보여줌) -->
                <!-- 2. allow ip 선택 -->
                <!-- <span ㄴclass="pull-right">Version : <strong >{{ default_rule.version }}</strong></span> -->
                <b-form-select class="float-right ml-2" v-model="target_crs_rule" @change="() => change_main_policy = true" size="sm" style="max-width: 10rem;" :didsabled="server.is_del ? lock : lock = false">
                  <option v-for="(item, index) in crs_version_list" :key="index" :value="item">{{item.version}}</option>
                </b-form-select>
                <Bell style="float:right; margin-top:5px;" :size="20" :count="crs_rule_count" v-if="get_max_policy()" />
              </b-col>
            </b-row>
            <hr>
            <RuleService
              v-if="!quick_setting_status"
              :quick_setting="quick_setting"
              :ico="ico"
              @toggle_policy="toggle_policy"
              :service_lock = "server.is_del ? lock : lock = false"
            ></RuleService>
            <hr v-if="!quick_setting_status" class="animated fadeIn fadeOut">
            <template v-if="!quick_setting_status" class="animated fadeIn fadeOut">
              <RuleSelector
                class="table table_add"
                ref="RuleSelector"

                :rule_selected="sel_domain.rule"
                :rule_data="rule_set.rule"
                :rule_block="sel_domain.block"
                :rule_detect="sel_domain.detect"
                :mode="setting.mode"
                :level="setting.level"
                :rule_lock="server.is_del ? lock : lock = false"

                @policy_rule="policy_rule"
                @quick_policy_one="(data) => quick_setting = Object.assign({}, quick_setting, data)"
                @block_policy="(block) => sel_domain = Object.assign({}, sel_domain, { block : block })"
                @detect_policy="(detect) => sel_domain = Object.assign({}, sel_domain, { detect : detect })"
                @rule_sel="(x) => sel_domain = Object.assign({}, sel_domain, { rule : x })"
                v-bind:toss_rule="save"
                v-if="sel_domain"
              />
            </template>
          </b-tab>
          <!-- 방화벽 사용자 설정 -->
          <!-- custom 문법 체크가 필요함 -->
          <b-tab style="cursor: pointer;" title="Custom Policy (Custom-CRS)">
            <b-row>
              <b-col class="col-xl-12 col-md-12 d-flex align-self-center">
                <span class="">
                  <strong>User Custom CRS Setting</strong>
                  <br>
                  <b-badge variant="warning">Notice</b-badge> It is recommended to set only experts.
                </span>
              </b-col>
            </b-row>
            <b-row class="mt-5">
              <b-col class="col-xl-6 col-md-12 d-flex align-self-center">
                <span class="">
                  Allows the user to customize the rule.
                  <br><br>
                  Please specify the rule id 2000000~+ ID.
                </span>
              </b-col>
              <b-col class="col-xl-6 col-md-12 d-flex align-self-center">
                <span class="">
                  Rule 920350 about "Host Header is a numeric IP address"
                  <br><br>
                  Example : SecRuleUpdateActionById 920350 "t:none,msg:'Network Attack',allow"
                </span>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col class="col-xl-6 col-md-12 align-self-center">
                <b-form-group>
                  <b-form-input placeholder="Example) http://f1security.co.kr/warning.html" v-model="using_redir" @change="redir_change" :disabled="server.is_del ? lock : lock = false"></b-form-input>
                  <br>
                  <b-form-checkbox v-model="is_redir" @change="x => using_redir = x ? using_redir : ''" :disabled="server.is_del ? lock : lock = false">
                    <p class="text-danger text-bold">Provides redirection for detection in blocking mode</p>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col class="col-xl-6 col-md-12 align-self-center">
                <b-form-group>
                  <b-form-textarea id="ph_content" v-model="user.custom_rule" :rows="line_count()" :max-rows="80" :disabled="server.is_del ? lock : lock = false"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
          <!-- ip 관련 접근 제어 -->
          <b-tab style="cursor: pointer;" title="IP Address">
            <RuleIP
              class="animated fadeIn fadeOut"
              @block_ip="($val, key) => user.block_ip = $val"
              @allow_ip="($val, key) => user.allow_ip = $val"
              :origin="{ allow_ip : user.allow_ip, block_ip: user.block_ip }"
              :is_setup="false"
              :setting="{ mode: server.mode, level : setting.level }"
              :ip_lock = "server.is_del ? lock : lock = false"
            ></RuleIP>
          </b-tab>
          <b-tab style="cursor: pointer;" title="Path & Parameter(Query String)">
            <b-row>
              <b-col>
                <!-- @update 에서 key 는 구분자임 -->
                <!-- path 관련 사용자 정책 설정 -->
                <RuleCustom
                  class="animated fadeIn fadeOut"
                  :origin="user.path"
                  name="path"
                  :is_setup="false"
                  example="/admin,/manager"
                  @update="($val, key) => user.path = $val"
                  :custom_lock = "server.is_del ? lock : lock = false"
                ></RuleCustom>
              </b-col>
              <b-col>
                <!-- 파라미터 관련 사용자 설정 -->
                <!-- @update 에서 key 는 구분자임 -->
                <RuleCustom
                  class="animated fadeIn fadeOut"
                  :origin="user.parameter"
                  name="params"
                  example="id=test : Detects if query string has id=test,test : Detects if query string has test"
                  :is_setup="false"
                  @update="($val, key) => user.parameter = $val"
                  :custom_lock = "server.is_del ? lock : lock = false"
                ></RuleCustom>
              </b-col>
            </b-row>
          </b-tab>
          <!-- CUSTOM country code -->
          <b-tab style="cursor: pointer;" title="Country">
            <RuleCountry
              ref="_country"
              class="animated fadeIn fadeOut"
              :origin="user.country_code"
              :origin_use_geoip="user.use_geoip"
              :country_lock = "server.is_del ? lock : lock = false"

              name="country_code"
              @update="($val, key) => user.country_code = $val"
              @use_geoip="($val, key) => user.use_geoip = $val"
            />
          </b-tab>
          <b-tab style="cursor: pointer;" title="Method">
            <!-- :origin_use_geoip => :origin_use_method 로 변경
                  RuleMethod 에서는 :origin_use_geoip 가 없음 -->
            <RuleMethod
              ref="_method"
              class="animated fadeIn fadeOut"
              :origin="user.method_control"
              :origin_use_method="user.use_method"
              :method_lock = "server.is_del ? lock : lock = false"

              name="method"
              @update="($val, key) => user.method_control = $val"
              @use_method="($val, key) => user = Object.assign({}, user, { use_method : $val })"
            />
          </b-tab>
          <b-tab style="cursor: pointer;" title="Log" @click="refresh()">
            <b-row>
              <b-col>
                <strong>Displays the detection/blocking logs for the server.</strong><br><br>
                <span>* Only the last 50 real-time displays</span><br>
                <span v-if="th" class="float-right">
                  <i class="fa fa-refresh fa-spin"></i>
                  Real-time updating
                </span>
                <br><br>
                <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list" show-empty empty-text="not found"
                  :items="getItems" :fields="fields" :current-page="currentPage" :per-page="50">
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
                  </template>
                  <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
                  <template slot="created_at" slot-scope="row">{{ row.item.created_at| sdate }}</template>
                  <template slot="remote_addr" slot-scope="row">
                    {{row.item.remote_addr}}
                    <CountryFlag v-if="row.item.country" class="explain" :country="row.item.country" size='small'/>
                  </template>
                  <template slot="is_block" slot-scope="row">
                    <b-badge v-if="row.item.is_block && row.item.block_cnt > 0" variant="danger">Block</b-badge>
                    <b-badge v-else variant="warning">Detection</b-badge>
                  </template>
                  <template slot="message" slot-scope="row">
                    <strong @click="log_view(row.item)">
                      {{ruleI18n[row.item.message.details.ruleId] ? ruleI18n[row.item.message.details.ruleId]['ENG'] : row.item.message.message }}
                    </strong>
                  </template>
                  <template slot="ruleid" slot-scope="row">
                    {{row.item.message ? row.item.message.details.ruleId : row.item.m_id }}
                  </template>
                  <template slot="severity" slot-scope="row">
                    <span scope="row" v-if="row.item.message.details.severity == 0"><b-badge variant="danger">Emergency</b-badge></span>
                    <span scope="row" v-else-if="row.item.message.details.severity == 1"><b-badge variant="danger">Alert</b-badge></span>
                    <span scope="row" v-else-if="row.item.message.details.severity == 2"><b-badge variant="danger">Critical</b-badge></span>
                    <span scope="row" v-else-if="row.item.message.details.severity == 3"><b-badge variant="warning">Error</b-badge></span>
                    <span scope="row" v-else-if="row.item.message.details.severity == 4"><b-badge variant="warning">Warning</b-badge></span>
                    <span scope="row" v-else-if="row.item.message.details.severity == 5"><b-badge variant="info">Notice</b-badge></span>
                    <span scope="row" v-else-if="row.item.message.details.severity == 6"><b-badge variant="info">Info</b-badge></span>
                    <span scope="row" v-else><b-badge variant="dark">Not recognized</b-badge></span>
                  </template>
                  <template slot="uri" slot-scope="row">
                    {{row.item.uri | truncate(50) }}
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab style="cursor: pointer;" title="Monitoring">
            <b-row v-if="info.ms">
              <b-col class="rounded-lg pt-2 m-2" sm="2">
                <vue-speedometer
                    class="fadeIn fadeOut animated"
                    v-if="info.status && info.status.system_memory_info"
                    style="display:inline-block; height:90px; float:left;"
                    :width="100"
                    :height="100"
                    :needleHeightRatio="0.4"
                    :value="ramStatus"
                    :customSegmentStops='[0, 250, 750, 1000]'
                    :segmentColors='["#22dc6d", "#ffc90e", "#ed1c24"]'
                    :currentValueText="`RAM(${ramStatus} %)`"
                    :customSegmentLabels='[ { text: "L", position: "INSIDE", color: "#fff", }, { text: "N", position: "INSIDE", color: "#fff", }, { text: "H", position: "INSIDE", color: "#fff", }, ]'
                    :ringWidth="18"
                    :needleTransitionDuration="1000"
                    needleTransition="easeElastic"
                    needleColor="#a7ff83"
                    textColor="#000"
                  />

                  <br>
                  <vue-speedometer
                  class="fadeIn fadeOut animated"
                  v-if="info.status && info.status.system_cpu_info"
                  style="display:inline-block; height:90px; float:left;"
                  :width="100"
                  :height="100"
                  :needleHeightRatio="0.4"
                  :value="cpuStatus"
                  :customSegmentStops='[0, 250, 750, 1000]'
                  :segmentColors='["#22dc6d", "#ffc90e", "#ed1c24"]'
                  :currentValueText="`CPU(${cpuStatus / 10 } %)`"
                  :customSegmentLabels='[ { text: "L", position: "INSIDE", color: "#fff", }, { text: "N", position: "INSIDE", color: "#fff", }, { text: "H", position: "INSIDE", color: "#fff", }, ]'
                  :ringWidth="18"
                  :needleTransitionDuration="1000"
                  needleTransition="easeElastic"
                  needleColor="#a7ff83"
                  textColor="#000"
                />
              </b-col>
              <b-col class="rounded-lg pt-2 m-2">
                <folderSet  :disk_list="disckStatus"/>
              </b-col>
            </b-row>
            <!-- <b-row v-else>
              <b-col class="col-xl-12 col-md-12 align-self-center mt-3 text-center">
                <strong class="title">The agent is Offline</strong>
              </b-col>
            </b-row> -->
            <b-row>
              <b-col class="col-xl-12 col-md-12 align-self-center text-center">
                <b-form-group>
                  <div class="checkbox-switch float-right mr-3">
                    <input type="checkbox" class="input-checkbox" name="switch06" id="switch06" color="success" label variant="pill" v-model="setting.limit_mode" :disabled="server.is_del ? lock : setting_lock">
                    <div class="checkbox-animate disabled">
                      <span class="checkbox-off">OFF</span>
                      <span class="checkbox-on">ON</span>
                    </div>
                  </div>
                </b-form-group>
                <p style="display:inline-block; cursor: pointer;" @click="server.is_del ? lock : (stting_lock ? stting_lock : (setting.limit_mode = !setting.limit_mode))"> <span class="mr-3">Resource Monitoring Alert Setting</span> <i v-if="setting.limit_mode" class="fa fa-refresh fa-spin"></i></p>
                <br>
                <small class="text-danger">
                  If the system resource exceeds the threshold, a notification will be generated once for the first time, <br> and a notification can be made when the standard is normal. We recommend 90% threshold and 60% normal standard.
                </small>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col sm="2" class="mt-2">CPU Threshold(90%)</b-col>
              <b-col sm="2">
                <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="setting.limit_cpu" :disabled="server.is_del ? lock : setting_lock"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm="2" class="mt-2">RAM Threshold(90%)</b-col>
              <b-col sm="2">
                <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="setting.limit_ram" :disabled="server.is_del ? lock : setting_lock"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm="2" class="mt-2">Disk Threshold(90%)</b-col>
              <b-col sm="2">
                <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="setting.limit_disk" :disabled="server.is_del ? lock : setting_lock"></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
            <b-row>
              <!-- 여기서 라인 나눔 -->
              <b-col sm="2" class="mt-2">CPU Normal(60%)</b-col>
              <b-col sm="2">
                <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="setting.resolve_cpu" :disabled="server.is_del ? lock : setting_lock"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm="2" class="mt-2">RAM Normal(60%)</b-col>
              <b-col sm="2">
                <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="setting.resolve_ram" :disabled="server.is_del ? lock : setting_lock"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm="2" class="mt-2">Disk Normal(60%)</b-col>
              <b-col sm="2">
                <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="setting.resolve_disk" :disabled="server.is_del ? lock : setting_lock"></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </template>
      <template v-else>
        <b-card>
          <div class="text-center">
            <span class="font-weight-bold">Not found</span>
          </div>
        </b-card>
      </template>
    </b-card>
    <!-- for modal -->
    <b-modal title="Status Save?"  class="modal-warning" v-model="status_confirm" @ok="status_save" ok-variant="danger">
      <p>Turn off / turn on the firewall on that server.</p>
    </b-modal>
    <b-modal title="Rule Save?"  class="modal-warning" v-model="rule_confirm" @ok="save" ok-variant="danger" header-bg-variant="danger">
      <p>Save changed settings Incorrect rule settings may affect the service</p>
    </b-modal>
    <!-- 레벨 설명 모달 -->
    <b-modal title="Explain Level Coverage"  class="modal-info text-center" v-model="explain_level" ok-only no-close-on-backdrop ok-variant="outline-primary">
      <div class="text-center">
        <img src="img/waf_level.png" class="text-center" style="margin-left: auto; margin-right: auto;width: 90%;">
        <p class="text-dnager mt-3" style="font-weight:bold">
          The higher the level, the deeper the attack is detected.
        </p>
      </div>
      <div class="mt-3">
        Level 4 is detect by policy level 1 ~ 4<br>
        Level 3 is detect by policy level 1 ~ 3<br>
        Level 2 is detect by policy level 1 ~ 2<br>
        Level 1 is detect by policy level 1<br>
      </div>
    </b-modal>

    <!-- 다른 서버 적용 모달 -->
    <b-modal hide-footer title="Agents to apply the policy to" size="xl" v-model="apply_modal" header-bg-variant='warning'>
      <!-- <b-button size="sm" variant="primary" @click="() => { policy_list = server.policy_json.domains.map(r => r.domain) }"> Select All </b-button> -->
      <b-button size="sm" variant="warning" @click="policy_list = []"> Clear </b-button>
      <hr>
      <p class="m-2">
        <b-form-checkbox-group class="m-2"  v-model="policy_list">
          <b-form-checkbox v-for="policy in server.policy_json.domains" :key="policy.id"  :value="policy.domain">
            {{policy.domain}}
          </b-form-checkbox>
        </b-form-checkbox-group>
      </p>
      <hr v-if="apply_all_server && apply_all_server.length > 0">
      <b-badge variant="success" v-for="(item, index) in apply_all_server" :key="index" class="m-1">
        <h6 @click="multi_remove(index)" style="cursor:pointer;">{{item.nickname}} <span class="m-1" style="cursor:pointer;">X</span></h6>
      </b-badge>
      <hr>
      <agent-List :agent_id="server.id" :list_selected="apply_all_server"  :only_select="true" @multi_clear="multi_clear" @multi_all="multi_all" @multi_one="multi_one"></agent-List>
      <hr>
      <b-button block variant="warning" @click="apply_confirm_modal = true" class="m-1">Apply</b-button>
      <b-button block variant="info" @click="apply_modal = false" class="m-1">Close</b-button>
    </b-modal>
    <!-- 다른 서버 적용 모달 다시 확인 -->
    <!-- <b-modal hide-footer title="Confirm for apply to policy" size="xm" v-model="apply_confirm_modal" header-bg-variant='danger'>
      Are you sure apply setting to selected agent ?
      <hr>
      <b-button block variant="danger" @click="multi_save" class="m-1">Apply</b-button>
      <b-button block variant="info" @click="apply_confirm_modal = false" class="m-1">Close</b-button>
    </b-modal> -->
    <!-- 방화벽 운영 모드 관련 안내 모달 -->
    <b-modal title="Domain Manage" class="modal-info" size="xl" v-model="explain_user_crs" no-close-on-backdrop ok-only @ok="explain_user_crs = false" ok-variant="outline-primary">
      <b-table ref="_list" striped hover small fixed class="table-responsive-sm" :items="server && server.policy_json && server.policy_json.domains" :fields="domain_manage_fields" empty-text="not found">
        <template slot="domain" slot-scope="row">
          <b-form-input @change="change_policy_name" :disabled="('default' == row.item.domain && row.index == 0) || !row.item.temp" class="pull-right m-1" size="sm" v-model="row.item.domain"></b-form-input>
        </template>
        <template slot="status" slot-scope="row">
          <b-badge v-if="row.item.temp" variant="danger">Un Saved</b-badge>
          <b-badge v-else variant="success">used</b-badge>
          <span v-if="row.item.domain == sel_domain.domain">*</span>
        </template>
        <template slot="mode" slot-scope="row">
          <!-- {{row.item.mode}} -->
          <b-badge v-if="row.item.mode == codes.WAF_MODE_OFF.VALUE || row.item.mode == codes.WAF_MODE_OFF.TEXT" variant="secondary">Off</b-badge>
          <b-badge v-if="row.item.mode == codes.WAF_MODE_DETECTIONONLY.VALUE || row.item.mode == codes.WAF_MODE_DETECTIONONLY.TEXT" variant="warning">Detection</b-badge>
          <b-badge v-if="row.item.mode == codes.WAF_MODE_ON.VALUE || row.item.mode == codes.WAF_MODE_ON.TEXT" variant="danger">Block</b-badge>
        </template>
        <template slot="level" slot-scope="row">{{row.item.level}}</template>
        <!-- <template slot="button" slot-scope="row">
          <b-button size="sm" :disabled="row.item.temp" variant="outline-warning" @click="domain_manage_regist(row.item.domain, `${row.item.domain}.${(new Date()).getTime()}`)">Clone</b-button>
          <b-button v-if="row.item.domain != 'default'" size="sm" variant="outline-danger" @click="domain_direct_remove(row.item)">Remove!</b-button>
        </template> -->
      </b-table>
      <!-- <p>
        <span class="float-left font-weight-bold text-danger">When charging, subdomains will be charged to one domain.</span>
        <b-button class="pull-right m-1" size="sm" variant="success" @click="domain_manage_regist()">Add</b-button>
        <b-form-input class="pull-right m-1" size="sm" v-model="domain" @keyup.native.enter="domain_manage_regist()" placeholder="Domain Add Enter" style="max-width: 20rem;"></b-form-input>
      </p> -->
    </b-modal>
    <b-modal title="Domain Remove" class="modal-danger" v-model="explain_user_domain" no-close-on-backdrop @ok="domain_manage_remove()" header-bg-variant="danger">
      Are you sure you want to delete it?
      Deletion does not work.
    </b-modal>
    <!-- 모드 설명 모달 -->
    <b-modal title="Explain Mode"  class="modal-info text-center" v-model="explain_mode" ok-only no-close-on-backdrop ok-variant="outline-primary">
      <b-badge variant="warning">Notice</b-badge>
      <br>
      <strong> The policy security level defaults to 1 and higher levels may affect the service </strong><br>
      <hr>
      <strong> * Off : Disable Web Castle Activation </strong><br>
      <strong> * Detection : Detect Only while on Activation </strong><br>
      <strong> * On : Block While On Activation </strong><br>
      <!-- <strong> * Multiplexing : Managed by a multiplexed firewall policy </strong> -->
      <hr>
      <p class="text-center">
        <b-img v-bind="{ width: 300, height: 300, class: 'm1' }" src="img/multi.png" alt="Multiplexing"></b-img>
      </p>
    </b-modal>

    <!-- 모드 설명 모달 -->
    <b-modal title="Change Policy Main Version"  class="modal-warning text-center" v-model="change_main_policy" no-close-on-backdrop ok-variant="success" hide-footer>
      <b-badge variant="warning">Notice</b-badge>
      <strong> Change the firewall's policy </strong>
      <hr>
      <p>Policy Version [ {{crs_rule.version}} ] => <span class="font-weight-bold text-danger">[ {{target_crs_rule.version}} ]</span> </p>
      <hr>
      <p>Required Minimum agent version [ {{crs_rule.agent_version ? crs_rule.agent_version : '-'}} ] => <span class="font-weight-bold text-danger">[ {{target_crs_rule.agent_version ? target_crs_rule.agent_version : '-'}} ]</span> </p>
      <hr>
      <p class="text-danger">* The page will be refreshed by changing the main policy</p>
      <hr>
      <small class="font-weight-bold">* If you have problems after changing a policy, you can restore the policy again.</small>
      <hr>
      <div class="modal-footer">
        <b-button block class="btn btn-success" @click="change_crs">Update</b-button>
        <b-button block class="btn btn-light" @click="change_main_policy = false; target_crs_rule = crs_rule;">Cancel</b-button>
      </div>
    </b-modal>

    <!-- 이름 변경 모달 -->
    <b-modal title="NickName Modify" class="modal-warning text-center" v-model="nickname_modify_modal" no-close-on-backdrop ok-variant="outline-primary" 
    @ok="nickname_modify()" @cancel="nickname_modify_modal = false" cancel-variant="outline-dark">
      <p> You can change the nickname of the server. </p>
      <p> Please enter a nickname to change. The first time, the server name is the hostname </p>
      <p> <b> * Check Server Name </b> </p>
      <p> Origin Server Nickname : {{server.nickname}}  </p>
      <b-form-input v-model="modify_nickname" placeholder="Please enter a nickname to change."></b-form-input>
    </b-modal>

    <!-- 이름 변경 모달 -->
    <b-modal title="NickName Setting" class="modal-warning text-center" v-model="modal_name" no-close-on-backdrop  ok-only ok-variant="outline-primary">
      <p> You can name it differently from the server host name </p>
    </b-modal>

    <!-- 로그 상세 모달 -->
    <b-modal title="Log Detail" size="xl" class="modal-warning text-center" v-model="modal_log" no-close-on-backdrop ok-variant="success" hide-footer>
      <LogDetail :id="modal_log_id" />
    </b-modal>

    <!-- 삭제 모달 -->
    <b-modal class="modal-dialog modal-dialog-centered modal-danger" title="Deletion of information" v-model="modal_del" @ok="remove" 
    @cancel="del_nickname = '';" header-bg-variant="danger" ok-variant="outline-danger" cancel-variant="outline-dark">
    <p> Agent deletion from the server does not automatically delete it Server recommends deleting first  </p>
      <p> If deleted, the firewall will not be processed.  </p>
      <p> <b> * Check Server Name </b> </p>
      <p> Delete Server Nickname : {{del_info.nickname}}  </p>
      <b-form-input v-model="del_nickname" placeholder="Typing The name of the server you want to unregister"></b-form-input>
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
